<template>
  <a target="_blank" rel="noopener noreferrer" :href="listViewUrl">
    <span class="list-view-link-text">{{ this.$t('label.listviewlink') }}</span>
  </a>
</template>

<script>
import ListViewLinkMixin from '@/mixins/ListViewLinkMixin'

export default {
  name: 'ListViewLink',
  mixins: [ListViewLinkMixin],
}
</script>
<style lang="postcss" scoped>
.list-view-link-text {
  @apply text-gray-700 text-xs;
}
</style>
